import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WinnipegsCleanAirAuthority from "./sections/WinnipegsCleanAirAuthority";
import WhyChooseTrustedInspections from "./sections/WhyChooseTrustedInspections";
import ProfessionalPlumbingSolutions from "./sections/ProfessionalPlumbingSolutions";
import AboutAndFacilities from "./sections/AboutAndFacilities";
import ClientReviews from "./sections/ClientReviews";
import OurInspectionProcess from "./sections/OurInspectionProcess";
import HowItWorks from "./sections/HowItWorks";
import TheTrustedInspectionsAdvantage from "./sections/TheTrustedInspectionsAdvantage";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import ServiceAreas from "./sections/ServiceAreas";
import ReachOutToTheShop from "./sections/ReachOutToTheShop";
import CallToAction from "./sections/CallToAction";
import CompanyDirectory from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WinnipegsCleanAirAuthority />
      <WhyChooseTrustedInspections />
      <ProfessionalPlumbingSolutions />
      <AboutAndFacilities />
      <ClientReviews />
      <OurInspectionProcess />
      <HowItWorks />
      <TheTrustedInspectionsAdvantage />
      <ClientSuccessStories />
      <ServiceAreas />
      <ReachOutToTheShop />
      <CallToAction />
      <CompanyDirectory />
    </div>;
}